<script setup>
import { reactiveOmit } from "@vueuse/core";
import { PopoverContent, PopoverPortal, useForwardPropsEmits } from "reka-ui";
import { cn } from "@/lib/utils";

defineOptions({
  inheritAttrs: false,
});

// Jedes Boolean hier traegt "default: undefined". Ohne das macht Vue aus einem
// fehlenden Boolean false - und ein durchreichender Wrapper wuerde damit den
// Default von reka-ui ueberschreiben, statt ihn gelten zu lassen. Konkret war
// dadurch avoidCollisions ueberall aus (reka-ui: true), Dialoge und Dropdowns
// waren nicht modal (reka-ui: true) und Collapsible haengte seinen Inhalt nicht
// aus (reka-ui: unmountOnHide true). Beim Nachgenerieren einer Komponente mit
// der shadcn-CLI faellt das wieder heraus - dann erneut setzen.

const props = defineProps({
  forceMount: { type: Boolean, required: false, default: undefined },
  side: { type: null, required: false },
  sideOffset: { type: Number, required: false, default: 4 },
  align: { type: null, required: false, default: "center" },
  alignOffset: { type: Number, required: false },
  // Siehe Kopf der Datei: default: undefined laesst reka-ui entscheiden.
  avoidCollisions: { type: Boolean, required: false, default: undefined },
  collisionBoundary: { type: null, required: false },
  collisionPadding: { type: [Number, Object], required: false },
  arrowPadding: { type: Number, required: false },
  sticky: { type: String, required: false },
  hideWhenDetached: { type: Boolean, required: false, default: undefined },
  positionStrategy: { type: String, required: false },
  updatePositionStrategy: { type: String, required: false },
  disableUpdateOnLayoutShift: { type: Boolean, required: false, default: undefined },
  prioritizePosition: { type: Boolean, required: false, default: undefined },
  reference: { type: null, required: false },
  asChild: { type: Boolean, required: false, default: undefined },
  as: { type: [String, Object, Function], required: false },
  disableOutsidePointerEvents: { type: Boolean, required: false, default: undefined },
  class: { type: null, required: false },
});
const emits = defineEmits([
  "escapeKeyDown",
  "pointerDownOutside",
  "focusOutside",
  "interactOutside",
  "openAutoFocus",
  "closeAutoFocus",
]);

const delegatedProps = reactiveOmit(props, "class");

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <PopoverPortal>
    <PopoverContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        cn(
          'z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          props.class,
        )
      "
    >
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
